import React from 'react';
import RegOptionsSection from './RegOptionsSection';

class RegOptionsContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataloaded: false
        }

        this.refreshComponent = this.refreshComponent.bind(this);
    }

    refreshComponent() {
        this.props.onPaymentAmountChanged()
    }

    render() {
       //console.log("regoptions container")
        return (

            <div className="reg-options-div" style={global.$registrationform.styles.regoptions.maindiv}>
                {/* section names from webconfig (one,two,three,four,five) */}
                <RegOptionsSection formtype={this.props.type} tabid={this.props.tabid} groupid="one" refreshComponent={this.refreshComponent} />
                <RegOptionsSection formtype={this.props.type} tabid={this.props.tabid} groupid="two" refreshComponent={this.refreshComponent} />
                <RegOptionsSection formtype={this.props.type} tabid={this.props.tabid} groupid="three" refreshComponent={this.refreshComponent} />
                <RegOptionsSection formtype={this.props.type} tabid={this.props.tabid} groupid="four" refreshComponent={this.refreshComponent} />
                <RegOptionsSection formtype={this.props.type} tabid={this.props.tabid} groupid="five" refreshComponent={this.refreshComponent} />
            </div>
        );
    }

}

export default RegOptionsContainer;